export const FOLLOW_UP_STATUS_ENUM = {
  0: { text: '未跟进', status: 'Default' },
  1: { text: '正在跟进', status: 'Processing' },
  2: { text: '已成交', status: 'Success' },
  3: { text: '暂无意向', status: 'Error' },
  4: { text: '已丢单', status: 'Warning' },
};

export const FOLLOW_UP_STATUS_OPTIONS = Object.entries(
  FOLLOW_UP_STATUS_ENUM,
).map(([value, { text }]) => ({
  label: text,
  value: Number(value),
}));

export const LEAD_GRADE_ENUM = {
  A: { text: 'A 级', status: 'Success' },
  B: { text: 'B 级', status: 'Processing' },
  C: { text: 'C 级', status: 'Warning' },
  D: { text: 'D 级', status: 'Default' },
};

export const LEAD_GRADE_OPTIONS = Object.entries(LEAD_GRADE_ENUM).map(
  ([value, { text }]) => ({
    label: text,
    value,
  }),
);
